import React, { FC } from 'react'
import { RouteComponentProps } from "@reach/router"

const Explorer: FC<RouteComponentProps> = (props) => {
  return (
    <div></div>
  )
}

export default Explorer
